import { render } from "./appSlider.vue?vue&type=template&id=75eb1f20"
import script from "./appSlider.vue?vue&type=script&lang=js"
export * from "./appSlider.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Awamer work\\my projects\\Nuxt\\A new work\\saqf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__